/**
 * `controller` 内部の小道具。
 *
 * `core/internal.ts` の `at` と同じもの。レイヤをまたいで内部関数を共有しないために複製している
 * （`internal` は各レイヤの私物であって公開インターフェースではない。`view/internal.ts` と同様）。
 */

/** 添字アクセスの結果を `undefined` を含まない型で受け取る。 */
export function at<T>(xs: ArrayLike<T | undefined>, i: number): T {
  const value = xs[i];
  /* v8 ignore next */
  if (value === undefined)
    throw new Error(`内部エラー: 添字 ${i} が範囲外です（長さ ${xs.length}）。`);
  return value;
}
